import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Button from 'react-bootstrap/lib/Button';
import Image from 'react-bootstrap/lib/Image';

import I18nLink, { redirect } from 'widgets/I18nLink';
import CurrencySwitcher from './CurrencySwitcher.js';
import LanguageSwitcher from './LanguageSwitcher.js';
import logoImg from 'images/logo.png';
import './header.css';

function isProfilePath(pathname) {
  const patterns = [/^\/\w{2}\/profile/];
  for (let p of patterns) {
    if (p.test(pathname)) {
      return true;
    }
  }

  return false;
}

class Header extends Component {
  onLogin() {
    redirect('/accounts/register/');
  }

  onLogout() {
    this.props.onLogout();
    redirect('/');
  }

  onAddRental() {
    redirect('/companies/register/');
  }

  render() {
    const { t, user } = this.props;
    const isAuthorized = !!user.id;
    const showExtra = isAuthorized &&
      isProfilePath(this.props.location.pathname);

    const isDistributor = user.isDistributor;

    return (
      <div className="header">
        <Grid>
          <Row className="header-container">
            <Col md={4} sm={5} xs={6} className="left-column">
              <I18nLink className="header-logo" to="/">
                <Image
                  alt="bikesbooking.com"
                  src={logoImg}
                  width={516}
                  height={74}
                  responsive
                />
              </I18nLink>
            </Col>

            <Col lg={3} md={3} sm={3} xs={4} className="center-column">
              <CurrencySwitcher />

              <LanguageSwitcher />
            </Col>

            <Col lg={5} md={5} sm={4} xs={2} className="right-column">
              {(!isAuthorized) &&
                <Button className="auth-btn" onClick={this.onLogin.bind(this)}>
                  <span className="user-icon hidden-lg" />
                  <span className="visible-lg-inline">{t('Login / Sign up')}</span>
                </Button>
              }

              {(!isAuthorized) &&
                <Button bsStyle="primary" className="add-rental-btn" onClick={this.onAddRental.bind(this)}>
                  <span className="visible-lg-inline visible-md-inline">{t('Add rental company')}</span>
                  <span className="hidden-lg hidden-md">{t('Add rental')}</span>
                </Button>
              }

              {(isAuthorized) &&
                <div className="profile-links hidden-xs">
                  <I18nLink to="/profile/" className="profile-username">
                    {user.name || user.email}
                  </I18nLink>

                  {(isDistributor) &&
                    <I18nLink className="profile-item" to="/profile/companies/">
                      {t('Companies')}
                    </I18nLink>
                  }

                  {(!isDistributor) &&
                    <I18nLink className="profile-item" to="/profile/bookings/">
                      {t('Bookings')}
                    </I18nLink>
                  }
                </div>
              }

              {(isAuthorized) &&
                <Button className="auth-btn hidden-xs" onClick={this.onLogout.bind(this)}>
                  <span className="logout-icon" />
                </Button>
              }

              {(isAuthorized) &&
                <I18nLink className="profile-item hidden-sm hidden-md hidden-lg" to="/profile/">
                  <Button className="auth-btn">
                    <span className="user-icon" />
                  </Button>
                </I18nLink>
              }
            </Col>
          </Row>

          {showExtra &&
            <div className="additional-links">
              <Col xs={12} className="hidden-sm hidden-md hidden-lg">
                {(isDistributor) &&
                  <I18nLink className="profile-item" to="/profile/companies/">
                    {t('Companies')}
                  </I18nLink>
                }

                {(!isDistributor) &&
                  <I18nLink className="profile-item" to="/profile/bookings/">
                    {t('Bookings')}
                  </I18nLink>
                }

                {(isAuthorized) &&
                  <I18nLink className="profile-item" onClick={this.onLogout.bind(this)}>
                    {t('Logout')}
                  </I18nLink>
                }
              </Col>
            </div>
          }
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js